<template>
  <div class="cloud-design-fixed">
    <iframe
      id="cloud-design"
      :src="url"
      width="100%"
      height="100%"
      scrolling="auto"
    ></iframe>
  </div>
</template>

<script>
import { $createCase } from "@/api/index";

export default {
  name: "Home",
  data() {
    return {
      preventFallback: false,
      centerDialogVisible: false,
      bannerIndex: 0,
      card_index: 0,
      materialShareIndex: "",

      input2: "111",
      trainingNotice1: [],

      text: {},
      url: "",
      executeCnce: false,
      msgOperate: {
        kjl_completed: {
          title: "退出工具",
          trigger: () => {
            this.executeCnce = true;
            this.outkjl();
          },
        },
        kjl_logout: {
          title: "退出工具",
          trigger: () => {
            this.executeCnce = true;
            this.outkjl();
          },
        },
      },
    };
  },
  computed: {
    //计算属性
  },
  components: {},
  created() {
    this.createCase(this.$route.query.url);
    this.preventFallback = true;
    window.onbeforeunload = function (e) {
      e = window.event || e;
      e.returnValue = "系统可能不会保存您所做的更改";
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.preventFallback) {
      // this.$toast('返回请点击左上角回退按钮')
      this.$router.go(1);
      this.onCloseWindow();
      return false;
    } else {
      next();
    }
  },

  beforeDestroy() {
    if ("addEventListener" in document) {
      window.removeEventListener("message", this.callbackMessage, false);
    } else if ("attachEvent" in document) {
      window.detachEvent("onmessage", this.callbackMessage);
    }
    window.onbeforeunload = function (e) {};
  },
  mounted() {},
  methods: {
    createCase(url) {
      this.url = decodeURIComponent(url);
      //   $createCase()
      //     .then((response) => {
      //       if (response) {
      //         this.url = response.data.replace("dest=0", "dest=1");
      //         let iframe = document.getElementById("cloud-design");
      //         iframe.onload = () => {
      //           let doc = iframe.contentWindow || iframe.contentDocument;
      //           console.log(doc);
      //           this.onBindPostMessage();
      //         };
      //       }
      //     })
      //     .catch((res) => {
      //       this.preventFallback = false;
      //       this.$router.go(-1);
      //     });
    },
    // 返回上一页吗 执行事件
    onCloseWindow() {
      setTimeout(() => {
        this.$confirm("系统可能不会保存您所做的更改", "系统提示", {
          distinguishCancelAndClose: true,
          showClose: false,
          confirmButtonText: "继续设计",
          cancelButtonText: "离开",
          confirmButtonClass: "confirm-button",
          cancelButtonClass: "cancel-button",
        })
          .then(() => {})
          .catch((action) => {
            this.preventFallback = false;
            this.executeCnce = false;
            this.$router.go(-1);
          });
      }, 400);
      return false;
    },
    callbackMessage(ev) {
      if (
        ev.origin === "http://www.kujiale.com" ||
        ev.origin === "http://yun.kujiale.com" ||
        ev.origin === "https://www.kujiale.com" ||
        ev.origin === "https://yun.kujiale.com"
      ) {
        if (typeof ev.data == "string" && ev.data.indexOf("{") != -1) {
          try {
            let msg = JSON.parse(ev.data);
            if (msg.action) {
              if (!this.executeCnce) {
                this.msgOperate[msg.action].trigger();
              }
            }
          } catch (error) {
            console.log(error);
          }
        }

        // handle message in ev ...
        // var data = JSON.parse(ev.data)
      }
    },
    onBindPostMessage() {
      if (window.postMessage) {
        if ("addEventListener" in document) {
          window.addEventListener("message", this.callbackMessage, false);
        } else if ("attachEvent" in document) {
          window.attachEvent("onmessage", this.callbackMessage);
        }
      } else {
        // 如果不支持postMessage， 则使用ie6/7的window共有属性navigator进行hack
        window.navigator.listenKJL = function (msg) {
          alert(msg);
          // var data = JSON.parse(ev.data)
        };
      }
    },
    outkjl() {
      this.$confirm("请问您想退回哪里", "系统提示", {
        distinguishCancelAndClose: true,
        showClose: false,
        confirmButtonText: "设计岛-云设计方案",
        cancelButtonText: "商家后台",
        customClass: "custom-class-confirm",
      })
        .then(() => {
          this.preventFallback = false;
          this.executeCnce = false;
          this.$router.push("/clouddesignsolution");
        })
        .catch((action) => {
          this.preventFallback = false;
          this.executeCnce = false;
          window.location.href =
            "https://www.kujiale.com/pub/saas/workbench/index";
        });
    },
  },
};
</script>

<style>
.cloud-design-fixed {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 889;
  width: 100%;
  height: 100vh;
  background-color: #000;
}
.container {
  height: 90vh;
  overflow: scroll;
}
/* ::v-deep {
    .confirm-button {
      background-color: #ebeef5;
    }
    .cancel-button {
      background-color: "#409EFF";
    }
  } */
/* .el-breadcrumb__inner {
    font-size: 14px;
     
    color: #999999 !important;
    font-weight: 400;
  }
  .el-breadcrumb__inner.is-link:hover {
    color: #999999 !important;
  } */

.el-message-box__wrapper {
  z-index: 9999999 !important;
}
</style>
